<template>
  <div class="school_info ma-0">
    <v-tabs
      class="elevation-2"
      background-color="#f5f5f5"
      color="red"
      slider-size="4"
    >
      <v-tab disabled>
      </v-tab>
      <v-tab :href="`#tab-school-info`">
        {{ $t("manage.by_school.school_info.tab.school_info") }}
      </v-tab>
      <v-tab-item :value="'tab-school-info'">
        <SchoolInfo />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import SchoolInfo from "@/components/management/info/SchoolInfo.vue";

export default {
  name: "experiment_list",
  components: {
    SchoolInfo
  },
  mixins: [],
  data: function () {
    return {
      name: "",
      school_id: null,
      role: null,
      drawer: true,
      mini: true,
      dialog: false,
      breadcrumbs: [{text: "School Info"}],
      api:{
        school_id: null,
        school_name: null,
        school_chi_name: null,
      },
    };
  },
  mounted: function () {
  },
  methods: {
    back(){
      var self = this;
      self.$cookies.remove("experiment");
      self.$cookies.remove("equipment_id");
      self.$router.push("/admin/management/");
    },
    beforeWindowUnload (e) {
      if (this.form_dirty) {
        e.preventDefault()
        e.returnValue = ''
      }
    },
  },
  beforeRouteLeave (to, from, next) {
    if (this.form_dirty) {
      next(false)
      window.location = to.path // this is the trick
    } else {
      next()
    }
  },
  created () {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  }
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>